//const queryString = require('query-string');
import {escape} from 'html-escaper';

/**
 * Loosely based on YUI's sub function.
 * 
 * Performs `{placeholder}` substitution on a string. The object passed as the 
 * second parameter provides values to replace the `{placeholder}`s.
 * `{placeholder}` token names must match property names of the object. For example,
 * 
 *`var greeting = Y.Lang.sub("Hello, {who}!", { who: "World" });`
 *
 * `{placeholder}` tokens that are undefined on the object map will be left 
 * intact (leaving unsightly `{placeholder}`'s in the output string). 
 *
 * @method sub
 * @param {string} s String to be modified.
 * @param {object} o Object containing replacement values.
 * @return {string} the substitute result.

 */

const SUBREGEX = /\{\s*([^}]+?)\s*\}/g;

const parametermap = {
    "[[formValue|firstname]]": "firstname"
};

const sub = function(s, usp) {
    return s.replace(SUBREGEX, function (match, key) {
        const value = usp.get(key);
        return value === null ? match : escape(value);
    });
};

/*
 */
const usp = new URLSearchParams(location.search);

// Apply synonyms for query parameters.
// For each synonym...
for (const [key, value] of Object.entries(parametermap)) {
    // ...if the synonym has been specified as a parameter, add it under its mapped name.
    if (usp.get(key)) {
        usp.set(value, usp.get(key));
    }
}

const el = document.body;
let html = el.innerHTML;
html = sub(html, usp);
el.innerHTML = html;